import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";

export default function GuruInfo() {
  const [guru, setGuru] = useState([]);
  const [filter, setFilter] = useState("Semua");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGuru = async () => {
      try {
        const snap = await getDocs(collection(db, "guruInfo"));
        const data = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setGuru(data);
      } catch (err) {
        console.error("fetch guru error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchGuru();
  }, []);

  const filteredGuru =
    filter === "Semua"
      ? guru
      : guru.filter(
          (g) =>
            g.jabatan &&
            g.jabatan.toLowerCase() === filter.toLowerCase()
        );

  const kategori = [
    "Semua",
    ...Array.from(new Set(guru.map((g) => g.jabatan).filter(Boolean))),
  ];

  return (
    <section
      className="guru-info-section py-5"
      style={{
        background:
          "linear-gradient(to bottom, #ffffff 0%, #e8f1ff 50%, #ffffff 100%)",
      }}
    >
      <div className="container">
        <h4
          className="fw-bold mb-4 text-center"
          style={{ color: "#0d47a1" }}
        >
          Informasi Guru & Staf
        </h4>

        {/* Filter */}
        <div className="d-flex justify-content-center mb-4 flex-wrap gap-2">
          {kategori.map((k, idx) => (
            <button
              key={idx}
              className={`btn btn-sm rounded-pill px-3 ${
                filter === k ? "btn-primary" : "btn-outline-primary"
              }`}
              style={{
                transition: "all 0.3s ease",
                fontWeight: 500,
              }}
              onClick={() => setFilter(k)}
            >
              {k}
            </button>
          ))}
        </div>

        {loading ? (
          <p className="text-center mt-3">Memuat data guru...</p>
        ) : filteredGuru.length === 0 ? (
          <p className="text-muted text-center">
            Belum ada guru/staf pada kategori ini.
          </p>
        ) : (
          <div className="d-flex flex-wrap gap-4 justify-content-center">
            {filteredGuru.map((g) => (
              <div
                key={g.id}
                className="card border-0 shadow-sm"
                style={{
                  width: "190px",
                  borderRadius: "14px",
                  overflow: "hidden",
                  transition: "all 0.35s ease",
                }}
              >
                <Link
                  to={`/guru/${g.id}`}
                  className="text-decoration-none text-dark"
                >
                  <div style={{ overflow: "hidden" }}>
                    <img
                      src={g.fotoUrl}
                      alt={g.nama}
                      className="card-img-top"
                      style={{
                        height: "260px",
                        objectFit: "cover",
                        transition: "transform 0.5s ease",
                      }}
                    />
                  </div>

                  <div
                    className="card-body text-center p-3"
                    style={{
                      background:
                        "linear-gradient(135deg, #ffffff, #f1f6ff)",
                    }}
                  >
                    <p
                      className="fw-bold mb-1"
                      style={{ color: "#1b5e20" }}
                    >
                      {g.nama}
                    </p>
                    <small className="text-muted">{g.jabatan}</small>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Hover effect khusus card */}
      <style>
        {`
          .guru-info-section .card:hover {
            transform: translateY(-8px);
            box-shadow: 0 12px 28px rgba(0,0,0,0.15);
          }
          .guru-info-section .card:hover img {
            transform: scale(1.08);
          }
        `}
      </style>
    </section>
  );
}
